import React, { Component } from 'react';
import { Icon } from 'semantic-ui-react';

/**
 * @typedef {{
 *  name: string,
 *  onDelete?: () => void,
 *  style?: React.CSSProperties,
 *  className?: string
 * }} Props
 * @extends {Component<Props>}
 */
export default class Tag extends React.Component {
  render() {
    const {
      name, onDelete, style, className
    } = this.props;

    return (
      <div className={`global-tag coloured background ${className || ''}`} style={style}>
        <span>{name}</span>

        {onDelete && <Icon className="times circle duotone" onClick={onDelete} />}
      </div>
    );
  }
}